/**
 * Whether the PayPal checkout is offered. Off since 2026-10-22: licenses are
 * sold outside the platform and granted from the admin panel. The backend has
 * its own switch (`PAYMENTS_ENABLED` in functions), which is the real lock —
 * this one only decides whether the pricing and checkout pages are reachable.
 */
export const PAYMENTS_ENABLED = import.meta.env.VITE_PAYMENTS_ENABLED === "true";
